import {UPDATE_TIME_IN_MS} from './ProjectDate.constants';
import {DI_TOKENS} from '@/di/di.tokens';

import {injected} from 'brandi';

import {Store} from '@/stores/Store';
import {GlobalWindow} from '@/types';

export class ProjectDate extends Store<{
  // серверное время в миллисекундах
  serverDate: number;
  // время прошедшее с последнего замера времени
  delta: number;
}> {
  private intervalId: number;
  private prevTime: number | null;

  constructor(private readonly globalWindow: GlobalWindow) {
    super({serverDate: new Date().getTime(), delta: 0});

    this.intervalId = -1;
    this.prevTime = null;
  }

  get date(): Date {
    return new Date(this.state.serverDate);
  }

  get delta(): number {
    return this.state.delta;
  }

  public setServerDate(serverDate: string): void {
    this.prevTime = null;

    this.setState({
      serverDate: new Date(serverDate).getTime(),
      delta: 0,
    });

    this.startUpdate();
  }

  // возвращает время в миллисекундах до переданнго времени
  // если переданное время уже было, вернет 0
  public getTimeBefore(date: string): number {
    return Math.max(0, Math.ceil(new Date(date).getTime() - this.date.getTime()));
  }

  public isBeforeNow(date: string): boolean {
    return this.getTimeBefore(date) === 0;
  }

  // было ли уже переданное время
  public isAfterNow(date: string): boolean {
    return this.getTimeBefore(date) !== 0;
  }

  private handleInterval = (): void => {
    const now = this.now();

    if (this.prevTime === null) {
      this.prevTime = now;
    }

    const delta = now - this.prevTime;

    this.setState({
      serverDate: this.state.serverDate + delta,
      delta,
    });

    this.prevTime = now;
  };

  private now(): number {
    return new Date().getTime();
  }

  private startUpdate(): void {
    if (this.intervalId !== -1) return;

    this.intervalId = this.globalWindow.setInterval(this.handleInterval, UPDATE_TIME_IN_MS);
  }
}

injected(ProjectDate, DI_TOKENS.globalWindow);
